module.exports = __webpack_public_path__ + "static/media/effet4.d4351577.ogg";